import React from 'react';
import Calendar from '../assets/images/icon-calendar-green.svg';

export default () => {
  return <img src={Calendar} alt="" />;
};
